"use client"

import { ReactNode, useRef } from "react"
import { PrimaryButton } from "src/components/common/PrimaryButton"
import { scrollToElement } from "src/utilities/scroll"

function findNearestParentWithId(element: HTMLElement) {
  let currentElement: HTMLElement | null = element

  while (currentElement && currentElement !== document.body) {
    if (currentElement.id) {
      return currentElement
    }
    currentElement = currentElement.parentElement
  }

  return null
}

function findNextSiblingWithId(element: HTMLElement) {
  let currentElement: Element | null = element.nextElementSibling

  while (currentElement) {
    if (currentElement.id) {
      return currentElement
    }
    currentElement = currentElement.nextElementSibling
  }

  return null
}

export type ScrollToNextSiblingButtonProps = {
  children: ReactNode
}

export const ScrollToNextIdButton = ({ children }: ScrollToNextSiblingButtonProps) => {
  const ref = useRef<any>(null)

  function scroll() {
    if (!ref.current) {
      return
    }

    const currSibling = findNearestParentWithId(ref.current)

    if (!currSibling) {
      reportError("ScrollToNextIdButton: No parent with id found")
      return
    }

    const nextSibling = findNextSiblingWithId(currSibling)

    if (!nextSibling) {
      reportError("ScrollToNextIdButton: No next sibling found: " + currSibling.id)
      return
    }

    scrollToElement(nextSibling)
  }

  return (
    <PrimaryButton ref={ref} color="primary" size="large" padding="large" className="mx-auto" onClick={scroll}>
      {children}
    </PrimaryButton>
  )
}
